const firebaseConfig = {
    apiKey: "AIzaSyAvbeRahOd-lpzZ3DmE2KXfWXTJBcKKYnQ",
    authDomain: "wecare-healthcare.firebaseapp.com",
    projectId: "wecare-healthcare",
    storageBucket: "wecare-healthcare.appspot.com",
    messagingSenderId: "992849719101",
    appId: "1:992849719101:web:81699ec9f87b287b67df54"
};

export default firebaseConfig;